export const buildPersistedProgressiveProfileOrEmpty = (data) => {
    if (!data) {
        return {
            firstName: null,
            lastName: null,
            email: null,
            companyName: null,
            jobTitle: null,
            phoneNumber: null,
            privacyConsentAccepted: false,
        };
    }
    return {
        firstName: data.firstName || null,
        lastName: data.lastName || null,
        email: data.email || null,
        companyName: data.companyName || null,
        jobTitle: data.jobTitle || null,
        phoneNumber: data.phoneNumber || null,
        privacyConsentAccepted: data.privacyConsentAccepted || false,
    };
};
